import { configRequest } from "config-request";
import { getRequestIns } from "shared";

const createDefaultPopupConfig = () => ({
  category_list: [],
  button_list: [],
  price_difference: undefined,
  price_difference_desc: "",
});

export const usePopupConfig = (lastRuleCheckContext) => {
  const isLoading = ref(false);
  const resultOptionList = ref(
    lastRuleCheckContext?.response?.rule_check_result_option_list || []
  );
  const popupConfig = ref(
    lastRuleCheckContext?.response?.option_change_popup ||
      createDefaultPopupConfig()
  );

  const defaultOptionList = computed(
    () =>
      popupConfig.value.category_list
        ?.filter((category) => category.type === "select")
        ?.flatMap((category) =>
          category.group_list?.flatMap((group) =>
            group.option_list?.filter((option) => option.selected === 1)
          )
        ) || []
  );

  const toggleOptionSelect = async (option, selected = true) => {
    if (!option?.feature_code) return;

    const nextDefaultOptionList = [...defaultOptionList.value];
    const defaultFeatureIndex = nextDefaultOptionList.findIndex(
      (defaultOption) => defaultOption.feature_code === option.feature_code
    );

    if (defaultFeatureIndex !== -1) {
      nextDefaultOptionList.splice(defaultFeatureIndex, 1);
    }
    if (selected) {
      nextDefaultOptionList.push(option);
    }

    try {
      isLoading.value = true;
      const { data: checkResult } = await configRequest(
        getRequestIns()
      ).ruleCheck({
        ...lastRuleCheckContext.request,
        switch_option_list: nextDefaultOptionList.map((nextOption) => ({
          feature_code: nextOption.feature_code || "",
          code: nextOption.code || "",
        })),
      });

      if (!checkResult) return;
      resultOptionList.value = checkResult.rule_check_result_option_list || [];
      if (checkResult.option_change_popup) {
        popupConfig.value = checkResult.option_change_popup;
      }
    } catch (error) {
      return;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    resultOptionList,
    popupConfig,

    toggleOptionSelect,
  };
};
